"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var __1 = require("../..");
if (process.env.NODE_ENV === 'development') {
    // Run react-axe in development only, so it does not affect performance
    // in production, and does not break unit tests either.
    // eslint-disable-next-line global-require
    var axe = require('react-axe');
    axe(react_1["default"], react_dom_1["default"], 1000);
}
// Expose components as globals for third-party reuse.
window.wagtail.components = {
    Icon: __1.Icon,
    Portal: __1.Portal,
};
/**
 * Add in here code to run once the page is loaded.
 */
document.addEventListener('DOMContentLoaded', function () {
    var explorerNode = document.querySelector('[data-explorer-menu]');
    var toggleNode = document.querySelector('[data-explorer-start-page]');
    if (explorerNode && toggleNode) {
        __1.initExplorer(explorerNode, toggleNode);
    }
    __1.initFocusOutline();
    __1.initSubmenus();
    __1.initIE11Warning();
    __1.initUpgradeNotification();
    __1.initSkipLink();
});
